<form style="padding: 50px;">
  <div class="form-group row">
    <label class="col-md-2 col-form-label col-form-label-sm"
      >数字(directive)</label
    >
    <div class="col-md-10">
      <input
        type="text"
        name="directive-input"
        appNumberInput
        value="10000"
        class="form-control input-sm"
      />
    </div>
  </div>
  <div class="form-group row">
    <label class="col-md-2 col-form-label col-form-label-sm">数字(model)</label>
    <div class="col-md-10">
      <input type="text" class="form-control input-sm" />
    </div>
  </div>
</form>
